
import { getChildLocationTypeForParent } from '../../locations';

class FeatureResponse {
    constructor( response, options ) {
        this.response = response;
        this.options = options;
        this.bbox = null;
        this.type = null;

        let f;
        if ( response.type === 'FeatureCollection' && response.features.length > 0 ) {
            f = response.features[ 0 ];
        } else if ( response.type === 'Feature' ) {
            f = response;
        }

        if ( f ) {
            if ( f.properties.searchSynonymousForLocationType && f.properties.searchSynonymousForLocationType.length > 0 && f.properties.searchSynonymousForLocationType !== 'none' ) {
                this.type = f.properties.searchSynonymousForLocationType;
            } else {
                this.type = f.properties.type;
            }
        } else {
            this.type = getChildLocationTypeForParent( this.options.featureSearchParams.get( 'parentType' ) );
        }

        if ( response.type === 'Feature' ) {
            this.bbox = [
                [
                    response.properties.boundingBoxMinLng,
                    response.properties.boundingBoxMinLat,
                ],
                [
                    response.properties.boundingBoxMaxLng,
                    response.properties.boundingBoxMaxLat,
                ],
            ];
        }

        if ( response.type === 'FeatureCollection' && response.bbox ) {
            this.bbox = [
                [ response.bbox[ 1 ], response.bbox[ 0 ] ],
                [ response.bbox[ 3 ], response.bbox[ 2 ] ],
            ];
        }
    }

    getBoundingBoxForFeature( featureID ) {
        const feature = this.response.features.find( ( feature ) => parseInt( feature.id ) === featureID );

        if ( !feature ) {
            return null;
        }

        return [
            [
                feature.properties.boundingBoxMinLng,
                feature.properties.boundingBoxMinLat,
            ],
            [
                feature.properties.boundingBoxMaxLng,
                feature.properties.boundingBoxMaxLat,
            ],
        ];
    }
}

export default FeatureResponse;
